module.exports = __webpack_public_path__ + "static/media/dried-fruits.dab9967f.jpg";